"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var shopManagement = {
  path: '/shop',
  component: _layout.default,
  redirect: '/shop/shopManagement',
  name: 'shop',
  alwaysShow: true,
  meta: {
    title: '门店管理',
    icon: 'shop'
  },
  children: [{
    path: 'shopManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/shop/shopManagement'));
      });
    },
    name: 'shopManagement',
    meta: {
      title: '门店列表',
      icon: ''
    }
  }, {
    path: 'invoice',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/shop/invoice'));
      });
    },
    name: 'invoice',
    meta: {
      title: '销方设置',
      icon: ''
    }
  }, {
    path: 'guestManagement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/shop/guestManagement'));
      });
    },
    name: 'guestManagement',
    meta: {
      title: '客位管理',
      icon: ''
    }
  }]
};
var _default = exports.default = shopManagement;